/* eslint-disable prettier/prettier */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable prettier/prettier */
import React, { useState } from "react";
import dayjs from "dayjs";
import moment from "moment";
import { SERVICES } from "../../../components/Layout/Services";
import { get } from "../../../components/Layout/ApiHandler/apihandler";
import Button from "../../../components/Layout/Button";
import DateRangePicker from "../Components/DateRangePicker/DateRangePicker";

export default function CancelledReciept() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [searched, setSearched] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const initialFormValue = {
    dateOfBirthFrom: new Date(),
    dateOfBirthTo: new Date(),
  };
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);
  const formattedStartDate = moment(
    initialAdvanceFormValue.dateOfBirthFrom
  ).format("YYYY-MM-DD");
  const formattedEndDate = moment(initialAdvanceFormValue.dateOfBirthTo).format(
    "YYYY-MM-DD"
  );

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const hh = String(date.getHours()).padStart(2, "0");
    const mm = String(date.getMinutes()).padStart(2, "0");
    const ss = String(date.getSeconds()).padStart(2, "0");

    const dd = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${hh}:${mm}:${ss}  ${dd}/${month}/${yyyy}`;
  };
  const [paymentMode, setPaymentMode] = useState("ALL");
  const [paymentModeError, setPaymentModeError] = useState(false);

  const fetchData = async () => {
     if (!paymentMode) {
    setPaymentModeError(true);
    return;
  }
    try {
      setLoading(true);
      setError(null);
      setSearched(true);
      setCurrentPage(1); // Reset to first page on new search

      const from = dayjs(formattedStartDate).format("YYYY-MM-DD");
      const to = dayjs(formattedEndDate).format("YYYY-MM-DD");

      const url = `${SERVICES.GET_CANCELLED_RECEIPT_REPORTS}?from=${from}&to=${to}&paymentMethod=${paymentMode}`;
      const response = await get(url);

      const result = await response.json();
      const sorted = (result.data || []).sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setData(sorted);
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  // Pagination calculations
  const totalRecords = data.length;
  const totalPages = Math.ceil(totalRecords / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (value) => {
    setItemsPerPage(value);
    setCurrentPage(1); // Reset to first page
  };

  // Generate page numbers
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      // eslint-disable-next-line no-plusplus
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else if (currentPage <= 3) {
      // eslint-disable-next-line no-plusplus
      for (let i = 1; i <= 4; i++) pages.push(i);
      pages.push("...");
      pages.push(totalPages);
    } else if (currentPage >= totalPages - 2) {
      pages.push(1);
      pages.push("...");
      // eslint-disable-next-line no-plusplus
      for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      pages.push("...");
      // eslint-disable-next-line no-plusplus
      for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
      pages.push("...");
      pages.push(totalPages);
    }
    return pages;
  };

  const downloadCSV = () => {
    if (!data || data.length === 0) {
      // eslint-disable-next-line no-alert
      alert("No data available to download.");
      return;
    }

    const headers = [
      "S.N.",
      "Order ID",
      "Member ID",
      "Name",
      "Amount",
      "Payment Method",
      "Pay At",
      "City",
      "State",
      "Updated By",
      "Reason",
    ];

    const rows = data.map((item, index) => [
      index + 1,
      item.orderId || "",
      item.memberId || "",
      item.fullName || "",
      item.amount || "",
      item.orderPaymentMethod || "",
      item.createdAt ? formatDate(item.createdAt) : "",
      item.memberCity || "",
      item.memberStateName || "",
      item.updatedBy || "",
      item.receiptCancelReason || "",
    ]);

    const csvContent = `data:text/csv;charset=utf-8,${[headers, ...rows]
      .map((e) => e.join(","))
      .join("\n")}`;

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute(
      "download",
      `cancelled_receipts_${formattedStartDate}_to_${formattedEndDate}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={{ padding: "20px", minHeight: "100vh", width: "100%" }}>
      <div style={{ margin: "0 auto" }}>
        <h2
          style={{
            fontSize: "28px",
            fontWeight: 700,
            marginBottom: "24px",
            color: "#1a202c",
            letterSpacing: "-0.5px",
          }}
        >
          Cancelled Transactions
        </h2>

        {/* Filters Box */}
        <div
          style={{
            padding: "24px",
            border: "1px solid #e2e8f0",
            borderRadius: "12px",
            background: "#ffffff",
            marginBottom: "24px",
            display: "flex",
            alignItems: "center",
            gap: "20px",
            flexWrap: "wrap",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          }}
        >
          <DateRangePicker
            label="Date Range"
            name="date"
            startDateVal={initialAdvanceFormValue.dateOfBirthFrom}
            endDateVal={initialAdvanceFormValue.dateOfBirthTo}
            onChange={(startDate, endDate) => {
              setInitialAdvanceFormValue({
                ...initialAdvanceFormValue,
                dateOfBirthFrom: startDate,
                dateOfBirthTo: endDate,
              });
            }}
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{
                fontSize: "14px",
                fontWeight: 500,
                color: "#4a5568",
                marginBottom: "6px",
              }}
            >
              Payment Mode <span style={{ color: "red" }}>*</span>
            </label>

            <select
              value={paymentMode}
              onChange={(e) => {
                setPaymentMode(e.target.value);
                setPaymentModeError(false);
              }}
              style={{
                padding: "10px",
                borderRadius: "8px",
                border: paymentModeError
                  ? "1px solid #dc2626"
                  : "1px solid #cbd5e0",
                minWidth: "220px",
                outline: "none",
                cursor: "pointer",
                background: "#fff",
              }}
              required
            >
              <option value="ALL">ALL</option>
              <option value="CASH">CASH</option>
              <option value="CHEQUE">CHEQUE</option>
              <option value="PAYMENT_GATEWAY">PAYMENT_GATEWAY</option>
            </select>

            {paymentModeError && (
              <span
                style={{ color: "#dc2626", fontSize: "12px", marginTop: "4px" }}
              >
                Payment mode is required
              </span>
            )}
          </div>

          <Button
            onClick={fetchData}
            style={{
              padding: "10px 24px",
              background: "#2563eb",
              color: "white",
              borderRadius: "8px",
              border: "none",
              fontWeight: 600,
              cursor: "pointer",
              marginTop: "25px",
              transition: "all 0.2s",
              boxShadow: "0 2px 4px rgba(37,99,235,0.2)",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#1d4ed8";
              e.target.style.boxShadow = "0 4px 8px rgba(37,99,235,0.3)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "#2563eb";
              e.target.style.boxShadow = "0 2px 4px rgba(37,99,235,0.2)";
            }}
          >
            Search
          </Button>
        </div>

        {/* Content Area */}
        {!searched ? (
          <div
            style={{
              padding: "40px",
              borderRadius: "12px",
              textAlign: "center",
              border: "1px solid #e2e8f0",
            }}
          >
            <p style={{ fontSize: "16px", color: "#718096" }}>
              Please select date range and click Search to view transactions.
            </p>
          </div>
        ) : loading ? (
          <div
            style={{
              background: "#ffffff",
              padding: "40px",
              borderRadius: "12px",
              textAlign: "center",
              border: "1px solid #e2e8f0",
            }}
          >
            <p style={{ fontSize: "18px", color: "#2563eb", fontWeight: 500 }}>
              Loading...
            </p>
          </div>
        ) : error ? (
          <div
            style={{
              background: "#ffffff",
              padding: "40px",
              borderRadius: "12px",
              textAlign: "center",
              border: "1px solid #fee",
            }}
          >
            <p style={{ color: "#dc2626", fontWeight: 500 }}>{error}</p>
          </div>
        ) : (
          <>
            {/* Stats and Controls Bar */}
            <div
              style={{
                background: "#ffffff",
                padding: "16px 20px",
                borderRadius: "12px 12px 0 0",
                border: "1px solid #e2e8f0",
                borderBottom: "none",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "16px",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    color: "#4a5568",
                    fontWeight: 500,
                  }}
                >
                  Total Records:{" "}
                  <strong style={{ color: "#2d3748" }}>{totalRecords}</strong>
                </span>
                <span style={{ color: "#cbd5e0" }}>|</span>
                <span style={{ fontSize: "14px", color: "#4a5568" }}>
                  Showing {indexOfFirstItem + 1} -{" "}
                  {Math.min(indexOfLastItem, totalRecords)} of {totalRecords}
                </span>
              </div>

              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <label
                  style={{
                    fontSize: "14px",
                    color: "#4a5568",
                    fontWeight: 500,
                  }}
                >
                  Items per page:
                </label>
                <select
                  value={itemsPerPage}
                  onChange={(e) =>
                    handleItemsPerPageChange(Number(e.target.value))
                  }
                  style={{
                    padding: "6px 12px",
                    borderRadius: "6px",
                    border: "1px solid #cbd5e0",
                    fontSize: "14px",
                    cursor: "pointer",
                    background: "#fff",
                    outline: "none",
                  }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <Button
                  onClick={downloadCSV}
                  style={{
                    padding: "8px 16px",
                    background: "#16a34a",
                    color: "white",
                    borderRadius: "8px",
                    border: "none",
                    fontWeight: 600,
                    cursor: "pointer",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  Download CSV
                </Button>
              </div>
            </div>

            {/* Table */}
            <div
              style={{
                overflowX: "auto",
                background: "#ffffff",
                borderRadius: "0 0 12px 12px",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "1px solid #e2e8f0",
                }}
              >
                <thead>
                  <tr style={{ background: "#4c4e8d" }}>
                    {[
                      "S.N.",
                      "Order ID",
                      "Member ID",
                      "Name",
                      "Amount",
                      "Payment Method",
                      "Pay At",
                      "City",
                      "State",
                      "Updated By",
                      "Reason",
                    ].map((h) => (
                      <th
                        key={h}
                        style={{
                          padding: "14px 12px",
                          textAlign: "left",
                          fontWeight: 600,
                          fontSize: "13px",
                          color: "#ffffff",
                          borderBottom: "2px solid #3d3f6d",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {currentItems.length === 0 ? (
                    <tr>
                      <td
                        colSpan={11}
                        style={{
                          padding: "40px",
                          textAlign: "center",
                          color: "#718096",
                          fontSize: "15px",
                        }}
                      >
                        No records found for the selected date range.
                      </td>
                    </tr>
                  ) : (
                    currentItems.map((item, index) => (
                      <tr
                        key={item.id}
                        style={{
                          background: index % 2 === 0 ? "#ffffff" : "#f7fafc",
                          transition: "background 0.15s",
                          borderBottom: "1px solid #e2e8f0",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#edf2f7")
                        }
                        // eslint-disable-next-line no-return-assign
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background =
                            index % 2 === 0 ? "#ffffff" : "#f7fafc")
                        }
                      >
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            color: "#4a5568",
                          }}
                        >
                          {indexOfFirstItem + index + 1}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            color: "#2d3748",
                            fontWeight: 500,
                          }}
                        >
                          {item.orderId}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            color: "#2d3748",
                          }}
                        >
                          {item.memberId}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            color: "#2d3748",
                          }}
                        >
                          {item.fullName}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            color: "#2d3748",
                            fontWeight: 600,
                          }}
                        >
                          ₹{item.amount}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            color: "#4a5568",
                          }}
                        >
                          {item.orderPaymentMethod}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "13px",
                            color: "#4a5568",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.createdAt ? formatDate(item.createdAt) : "-"}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            color: "#4a5568",
                          }}
                        >
                          {item.memberCity || "-"}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            color: "#4a5568",
                          }}
                        >
                          {item.memberStateName || "-"}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            color: "#4a5568",
                          }}
                        >
                          {item.updatedBy || "-"}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            color: "#4a5568",
                            maxWidth: "200px",
                          }}
                        >
                          {item.receiptCancelReason || "-"}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div
                style={{
                  background: "#ffffff",
                  padding: "16px 20px",
                  borderRadius: "0 0 12px 12px",
                  border: "1px solid #e2e8f0",
                  borderTop: "none",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  flexWrap: "wrap",
                  marginTop: "2px",
                }}
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 12px",
                    border: "1px solid #cbd5e0",
                    borderRadius: "6px",
                    background: currentPage === 1 ? "#f7fafc" : "#ffffff",
                    color: currentPage === 1 ? "#a0aec0" : "#4a5568",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    fontSize: "14px",
                    fontWeight: 500,
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    if (currentPage !== 1) {
                      e.target.style.background = "#edf2f7";
                      e.target.style.borderColor = "#a0aec0";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (currentPage !== 1) {
                      e.target.style.background = "#ffffff";
                      e.target.style.borderColor = "#cbd5e0";
                    }
                  }}
                >
                  Previous
                </button>

                {getPageNumbers().map((page, idx) =>
                  page === "..." ? (
                    <span
                      key={`ellipsis-${idx}`}
                      style={{ padding: "8px 4px", color: "#a0aec0" }}
                    >
                      ...
                    </span>
                  ) : (
                    <button
                      key={page}
                      onClick={() => handlePageChange(page)}
                      style={{
                        padding: "8px 14px",
                        border:
                          currentPage === page
                            ? "2px solid #4c4e8d"
                            : "1px solid #cbd5e0",
                        borderRadius: "6px",
                        background:
                          currentPage === page ? "#4c4e8d" : "#ffffff",
                        color: currentPage === page ? "#ffffff" : "#4a5568",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: currentPage === page ? 600 : 500,
                        minWidth: "40px",
                        transition: "all 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        if (currentPage !== page) {
                          e.target.style.background = "#edf2f7";
                          e.target.style.borderColor = "#a0aec0";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (currentPage !== page) {
                          e.target.style.background = "#ffffff";
                          e.target.style.borderColor = "#cbd5e0";
                        }
                      }}
                    >
                      {page}
                    </button>
                  )
                )}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "8px 12px",
                    border: "1px solid #cbd5e0",
                    borderRadius: "6px",
                    background:
                      currentPage === totalPages ? "#f7fafc" : "#ffffff",
                    color: currentPage === totalPages ? "#a0aec0" : "#4a5568",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                    fontSize: "14px",
                    fontWeight: 500,
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    if (currentPage !== totalPages) {
                      e.target.style.background = "#edf2f7";
                      e.target.style.borderColor = "#a0aec0";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (currentPage !== totalPages) {
                      e.target.style.background = "#ffffff";
                      e.target.style.borderColor = "#cbd5e0";
                    }
                  }}
                >
                  Next
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
